global.viewState = {
		myStudents:{
			scrollTop:0,
			openStudents:[]			
		}		
}

global.resizeIframe=function(obj) {
    obj.style.height = obj.contentWindow.document.body.scrollHeight + 'px';
  }